import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

function Section({ title, children }) {
  return (
    <section className="mb-10">
      <h2 className="font-mono text-base text-white uppercase tracking-wider mb-4 border-b border-[#2A2A2A] pb-3">
        {title}
      </h2>
      <div className="text-[#BEB3A6] font-sans leading-relaxed space-y-3 text-[0.95rem]">
        {children}
      </div>
    </section>
  );
}

export default function ContactPage() {
  return (
    <div className="bg-[#111111] min-h-screen">
      <Helmet>
        <title>Contact – Restricted Deals</title>
        <meta name="description" content="Get in touch with Restricted Deals for deal inquiries, partnership requests or general questions." />
        <link rel="canonical" href="https://restricteddeals.com/contact" />
      </Helmet>
      <SiteHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <p className="eyebrow eyebrow-red mb-4">// CONTACT</p>
        <h1 className="font-mono text-4xl md:text-5xl text-white uppercase tracking-tight mb-14">
          Get in touch
        </h1>

        <Section title="// GENERAL INQUIRIES">
          <p>For deal inquiries, partnership requests or general questions:</p>
          <p>
            Email:{" "}
            <a href="mailto:hello@restricteddeals.com" className="text-[#CC1A1A] hover:underline">
              hello@restricteddeals.com
            </a>
          </p>
          <p>
            Website:{" "}
            <a href="https://restricteddeals.com" className="text-[#CC1A1A] hover:underline">
              restricteddeals.com
            </a>
          </p>
        </Section>

        <Section title="// CRUISE & PACKAGE BOOKINGS">
          <p>For cruise and package bookings:</p>
          <p>
            The Better Fare —{" "}
            <a href="https://thebetterfare.com" className="text-[#CC1A1A] hover:underline" target="_blank" rel="noopener noreferrer">
              thebetterfare.com
            </a>
          </p>
        </Section>

        <Section title="// RESPONSE TIME">
          <p>Within 24 hours.</p>
        </Section>

        <div className="hr-dot my-10" />
        <div className="flex gap-6 text-[11px] font-mono tracking-widest uppercase text-[#555]">
          <Link to="/about" className="hover:text-white transition-colors">About</Link>
          <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
          <Link to="/cookies" className="hover:text-white transition-colors">Cookie Policy</Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
